import { Autocomplete } from '../../../models/autocomplete/autocomplete'

export function requestLocalidad (value) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_A_LOCALIDAD' })
    return Autocomplete.search('localidad', value)
      .then(values => {
        dispatch({ type: 'RECEIVE_A_LOCALIDAD', values })
      })
      .catch(_ => {
        dispatch({ type: 'RECEIVE_A_LOCALIDAD', values: [] })
      })
  }
}

export function requestEntity (entity, value) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_A_ENTITY' })
    return Autocomplete.search(entity, value)
      .then(values => {
        dispatch({ type: 'RECEIVE_A_ENTITY', entity, values })
      })
      .catch(_ => {
        dispatch({ type: 'RECEIVE_A_ENTITY', entity, values: [] })
      })
  }
}

export function obtenerEntityValues (entity, orderBy = null) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_A_ENTITY' })
    return Autocomplete.getEntityValues(entity, orderBy)
      .then(data => {
        const values = data
        dispatch({ type: 'RECEIVE_A_ENTITY', entity, values })
      })
      .catch(_ => {
        dispatch({ type: 'RECEIVE_A_ENTITY', entity, values: [] })
      })
  }
}
